<script context="module">
    import { isObjectEmpty } from "../../../../Utils/utilFunctions.svelte";

    export const createSidebarTooltip = (
        position = {},
        id,
        displayText = "",
    ) => {
        if (isObjectEmpty(position) || !id) return;

        const { top, right, bottom } = position;

        if (!top || !right || !bottom) return;

        const tooltip = document.createElement("div");

        tooltip.id = id;
        tooltip.textContent = displayText;

        const height = bottom - top;

        const topPosition =
            window.innerHeight >= bottom ? top : window.innerHeight - height;

        const leftPosition = right + 10;

        tooltip.style = `
            position: absolute;
            height: ${height}px;
            top: ${topPosition}px;
            left: ${leftPosition}px;
            width: auto;
            background-color: rgb(243 244 246);
            z-index: 9999;
            color: #000;
            padding: 5px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #8A3ED7;
            border-radius: 0.5rem;
        `;

        document.body.appendChild(tooltip);
    };

    export const removeSidebarTooltip = (id) => {
        if (!id) return;

        const tooltip = document.getElementById(id);

        tooltip && tooltip.remove();
    };
</script>
